import { useNotificationsSocket } from '~/features/notifications/hooks/useNotificationsSocket';
import { useResubmissionDueTimer } from '~/features/notifications/hooks/useResubmissionDueTimer';

// Note: component host so the Header can mount the bell's live updates conditionally (only for roles with the bell)
export const NotificationsLiveUpdates = () => {
    useNotificationsSocket();
    useResubmissionDueTimer();
    return null;
};
